/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetLeadAssignmentsRequest
 */
export interface SetLeadAssignmentsRequest {
    /**
     * 
     */
    owner_user_id?: string;
    /**
     * 
     */
    liaison_user_ids: Array<string>;
}

/**
 * Check if a given object implements the SetLeadAssignmentsRequest interface.
 */
export function instanceOfSetLeadAssignmentsRequest(value: object): value is SetLeadAssignmentsRequest {
    if (!('liaison_user_ids' in value) || value['liaison_user_ids'] === undefined) return false;
    return true;
}

export function SetLeadAssignmentsRequestFromJSON(json: any): SetLeadAssignmentsRequest {
    return SetLeadAssignmentsRequestFromJSONTyped(json, false);
}

export function SetLeadAssignmentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLeadAssignmentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner_user_id': json['owner_user_id'] == null ? undefined : json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'],
    };
}

export function SetLeadAssignmentsRequestToJSON(json: any): SetLeadAssignmentsRequest {
    return SetLeadAssignmentsRequestToJSONTyped(json, false);
}

export function SetLeadAssignmentsRequestToJSONTyped(value?: SetLeadAssignmentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['owner_user_id'],
        'liaison_user_ids': value['liaison_user_ids'],
    };
}

